import makeList from './makeList.js'

let viewFloor = 'インテルサットレドーム'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: 'インテルサットアンテナ レドーム(1)',
        file: './data/I36a.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 122.60536398467434, 339.71902937420174 ],
          syowaZoom: [ 454.34298440979956, 445.43429844097994 ],
        },
      },
      { description: 'インテルサットアンテナ レドーム(2)',
        file: './data/I36b_2.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 122.60536398467434, 339.71902937420174 ],
          syowaZoom: [ 282.8507795100223, 342.98440979955456 ],
        },
      },
      { description: 'インテルサットアンテナ レドーム制御室',
        file: './data/I36d.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 122.60536398467434, 339.71902937420174 ],
          syowaZoom: [ 456.57015590200444, 211.58129175946547 ],
        },
      },
      { description: 'インテルサットアンテナ レドーム制御室 入口',
        file: './data/I36c.JPG',
        rotation: 67.05809957126333,
        link: [
        ],
        info: [
        ],
        view: {
          syowa: [ 122.60536398467434, 339.71902937420174 ],
          syowaZoom: [ 525.6124721603563, 153.67483296213808 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
